import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Calculateur from "@/pages/Calculateur";
import Flotte from "@/pages/Flotte";
import APropos from "@/pages/APropos";
import Contact from "@/pages/Contact";
import LegalPage from "@/pages/LegalPage";
import NotFound from "@/pages/NotFound";
import Merci from "@/pages/Merci";
import {
  MENTIONS_LEGALES,
  CGV,
  CGU,
  CONFIDENTIALITE,
} from "@/config/legal";

// Retour en haut de page à chaque navigation (sauf ancre)
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Header />
        <main id="contenu">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/calculateur" element={<Calculateur />} />
            <Route path="/flotte" element={<Flotte />} />
            <Route path="/a-propos" element={<APropos />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/mentions-legales"
              element={<LegalPage content={MENTIONS_LEGALES} path="/mentions-legales" />}
            />
            <Route
              path="/conditions-generales-de-vente"
              element={<LegalPage content={CGV} path="/conditions-generales-de-vente" />}
            />
            <Route
              path="/conditions-generales-utilisation"
              element={<LegalPage content={CGU} path="/conditions-generales-utilisation" />}
            />
            <Route
              path="/politique-de-confidentialite"
              element={<LegalPage content={CONFIDENTIALITE} path="/politique-de-confidentialite" />}
            />
            <Route path="/merci" element={<Merci />} />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
